window.BoehmeColorGallery = (sectionId) => {
  const original = window.ThemeModule_Carousel(sectionId);

  return {
    ...original,
    boehmeFiltered: false,
    allBoehmeSlides: [],
    boehmeGroups: {},

    mounted() {
      const product = this.product;
      const options = product?.options || [];
      const variants = product?.variants || [];

      const optionName = (option) =>
        typeof option === 'string' ? option : option?.name || '';

      const colorIndex = options.findIndex((option) =>
        /colou?r/i.test(optionName(option))
      );

      const measureIndex = options.findIndex((option) =>
        /^(medidas?|size)$/i.test(optionName(option).trim())
      );

      const optionValue = (variant, index) =>
        index < 0
          ? undefined
          : variant?.options?.[index] || variant?.[`option${index + 1}`];

      const colorOf = (variant) => optionValue(variant, colorIndex);
      const measureOf = (variant) => optionValue(variant, measureIndex);

      const isBorlas =
        String(product?.id) === '15396919148795' ||
        product?.handle === 'borlas' ||
        product?.title?.trim().toLowerCase() === 'borlas';

      const mediaIds = product?.media?.map((media) => String(media.id)) || [];
      const colors = [...new Set(variants.map(colorOf).filter(Boolean))];

      const makeAnchors = (groupForVariant) => {
        const groups = [
          ...new Set(variants.map(groupForVariant).filter(Boolean))
        ];

        const anchors = groups
          .map((group) => {
            const positions = variants
              .filter((variant) => groupForVariant(variant) === group)
              .map((variant) =>
                mediaIds.indexOf(String(variant.featured_media?.id))
              )
              .filter((position) => position >= 0);

            return { group, position: Math.min(...positions) };
          })
          .filter((anchor) => Number.isFinite(anchor.position))
          .sort((a, b) => a.position - b.position);

        return { groups, anchors };
      };

      let groupOf = colorOf;
      let { groups, anchors } = makeAnchors(groupOf);

      if (isBorlas && measureIndex >= 0) {
        const colorAndMeasureOf = (variant) => {
          const color = colorOf(variant);
          const measure = measureOf(variant);

          return color && measure
            ? JSON.stringify([color, measure])
            : null;
        };

        const candidate = makeAnchors(colorAndMeasureOf);

        const sixGroupsOfFour =
          candidate.groups.length === 6 &&
          candidate.anchors.length === 6 &&
          candidate.anchors[0].position === 0 &&
          candidate.anchors.every((anchor, index) => {
            const nextPosition =
              candidate.anchors[index + 1]?.position ?? mediaIds.length;

            return nextPosition - anchor.position === 4;
          });

        if (sixGroupsOfFour) {
          groupOf = colorAndMeasureOf;
          groups = candidate.groups;
          anchors = candidate.anchors;
        }
      }

      if (
        colorIndex < 0 ||
        colors.length < 2 ||
        anchors.length !== groups.length ||
        new Set(anchors.map((anchor) => anchor.position)).size !==
          anchors.length
      ) {
        original.mounted.call(this);
        return;
      }

      this.track = this.$refs['carousel-track'];
      this.allBoehmeSlides = this.track ? [...this.track.children] : [];

      if (!this.track || this.allBoehmeSlides.length !== mediaIds.length) {
        original.mounted.call(this);
        return;
      }

      let anchorIndex = 0;

      mediaIds.forEach((id, index) => {
        while (
          anchorIndex + 1 < anchors.length &&
          index >= anchors[anchorIndex + 1].position
        ) {
          anchorIndex += 1;
        }

        this.boehmeGroups[id] = anchors[anchorIndex].group;
      });

      this.boehmeFiltered = true;

      this.track.addEventListener(
        'scroll',
        () => {
          if (this.boehmeSwitching) return;

          const origin = this.track.getBoundingClientRect();
          const vertical = this.mode === 'vertical';
          let closest = 0;
          let distance = Infinity;

          this.slides.forEach((slide, index) => {
            const box = slide.elem.getBoundingClientRect();
            const gap = Math.abs(
              vertical ? box.top - origin.top : box.left - origin.left
            );

            if (gap < distance) {
              closest = index;
              distance = gap;
            }
          });

          this.current_slide = closest + 1;
        },
        { passive: true }
      );

      this.$el.closest('[data-product-section]')?.addEventListener(
        'switch:product:variantchange',
        (event) => this.boehmeShowColor(groupOf(event.detail.variant))
      );

      this.boehmeShowColor(groupOf(this.current_variant));
    },

    boehmeShowColor(group) {
      if (!this.boehmeFiltered || !group) return;

      this.boehmeSwitching = true;

      const thumbnails =
        this.$refs['carousel-thumbnails']?.querySelectorAll('li') || [];

      const visible = [];

      this.allBoehmeSlides.forEach((elem, index) => {
        const show = this.boehmeGroups[elem.dataset.mediaId] === group;

        elem.style.display = show ? '' : 'none';
        elem.setAttribute('aria-hidden', String(!show));

        if (thumbnails[index]) {
          thumbnails[index].style.display = show ? '' : 'none';
        }

        if (show) visible.push(elem);
      });

      if (!visible.length) {
        this.allBoehmeSlides.forEach((elem, index) => {
          elem.style.display = '';
          elem.removeAttribute('aria-hidden');

          if (thumbnails[index]) {
            thumbnails[index].style.display = '';
          }
        });

        this.boehmeSwitching = false;
        return;
      }

      this.slides = visible.map((elem) => ({ elem }));
      this.total_slides = visible.length;
      this.current_slide = 1;

      visible.forEach((elem, index) => {
        elem.setAttribute(
          'aria-label',
          `Imagen ${index + 1} de ${visible.length}`
        );
      });

      this.$nextTick(() => {
        this.slideIntoView(this.slides[0], true);

        requestAnimationFrame(() => {
          this.boehmeSwitching = false;
        });
      });
    },

    activeMediaId() {
      return this.slides[this.current_slide - 1]?.elem.dataset.mediaId;
    },

    prevSlide() {
      if (!this.boehmeFiltered) return original.prevSlide.call(this);

      this.slideIntoView(
        this.slides[
          (this.current_slide - 2 + this.total_slides) % this.total_slides
        ]
      );
    },

    nextSlide() {
      if (!this.boehmeFiltered) return original.nextSlide.call(this);

      this.slideIntoView(this.slides[this.current_slide % this.total_slides]);
    },

    thumbnailFocus(index) {
      if (!this.boehmeFiltered) {
        return original.thumbnailFocus.call(this, index);
      }

      const target = this.allBoehmeSlides[index];
      const visibleIndex = this.slides.findIndex(
        (slide) => slide.elem === target
      );

      if (visibleIndex >= 0) {
        this.slideIntoView(this.slides[visibleIndex]);
      }
    },

    thumbnailKeyPress(direction) {
      if (!this.boehmeFiltered) {
        return original.thumbnailKeyPress.call(this, direction);
      }

      const next =
        direction === 'left'
          ? (this.current_slide - 2 + this.total_slides) % this.total_slides
          : this.current_slide % this.total_slides;

      const originalIndex = this.allBoehmeSlides.indexOf(
        this.slides[next].elem
      );

      this.$refs['carousel-thumbnails']
        ?.querySelector(`[data-slide="${originalIndex + 1}"]`)
        ?.focus();
    }
  };
};